import React, { useCallback } from "react";
import { connect } from "react-redux";

import useAutoRunning from "@app/component/flows/utils/useAutoRunning";
import Path from "@app/enum/Path";
import { getCurrentUser } from "@app/store/iam";
import { RootState } from "@app/store/rootReducer";

import ChecklistRunner from "../base/ChecklistRunner";

import { gettingStartedChecklistConfiguration } from "./configuration";

export interface GettingStartedChecklistProps {}

const GettingStartedChecklist = ({
  currentUser,
}: GettingStartedChecklistProps & ReturnType<typeof mapStateToProps>) => {
  const { handleHideConfirm, handleTourShow } = useAutoRunning(
    gettingStartedChecklistConfiguration.id,
    currentUser,
    useCallback((pathname: string) => pathname.startsWith(Path.DASHBOARD), [])
  );

  return (
    <ChecklistRunner
      descriptor={gettingStartedChecklistConfiguration}
      onHideConfirm={handleHideConfirm}
      onTourShow={handleTourShow}
    />
  );
};

const mapStateToProps = (state: RootState) => ({
  currentUser: getCurrentUser(state)!,
});

export default connect(mapStateToProps)(GettingStartedChecklist);
